module.exports = __webpack_public_path__ + "static/media/chengjiaokehuxinxijiaojiebiao.9428d1fd.png";